import { jsx as _jsx } from "react/jsx-runtime";
const SvgSlashForward = (props) => {
    if (process.env.NODE_ENV !== 'production') {
        if (props['aria-hidden'] !== 'true' && props['aria-label'] === undefined) {
            console.warn('aria-hidden="true" or aria-label should be passed to svg icon for better user experience. Use aria-label="" if you have reason to do so.');
        }
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", "data-svgtype": "icon-default", ...props, children: _jsx("path", { d: "M23.97 512a23.788 23.788 0 0 1-12.09-3.297C.437 502-3.406 487.3 3.281 475.9l272-464c6.688-11.45 21.38-15.3 32.84-8.562 11.44 6.703 15.28 21.41 8.594 32.84l-272 464C40.25 507.8 32.22 512 23.97 512z" }) }));
};
export default SvgSlashForward;
